import React, { useEffect, useState } from "react";
import { Paper, Skeleton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { WHITE, IRIS_60 } from "../../colors";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import { Box } from "@mui/system";

ChartJS.register(ArcElement, Tooltip, Legend);

ChartJS.register(ArcElement, Tooltip, Legend);

const CustomPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  paddingTop: 15,
  paddingBottom: 10,
  paddingLeft: 15,
  height: 380,
  paddingRight: 15,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  borderRadius: 10,
  minWidth: 250,
}));

export default function GenderDistrib(people) {
  console.log(people.people)
  const genderCounts = people?.people?.reduce((counts, candidate) => {
    const { gender } = candidate;
    if (gender === "male" || gender === "female" || gender === "") {
      counts[gender] = (counts[gender] || 0) + 1;
    }
    return counts;
  }, {});

  const genderData = {
    labels: Object.keys(genderCounts),
    datasets: [
      {
        data: Object.values(genderCounts),
        backgroundColor: ['#FF6384', '#36A2EB', ],
      },
    ],
  };

  const data = {
    labels: Object.keys(genderCounts),
    datasets: [
      {
        label: "# of Votes",
        data: Object.values(genderCounts),
        backgroundColor: ["#59A7FF",'#FFCE56', "#2CDDC7"],
        borderColor: ["#59A7FF", "#2CDDC7"],
        borderWidth: 1,
      },
    ],
  };

  return (
    <CustomPaper>
      <Typography fontSize={18} color={IRIS_60} style={{ marginLeft: 25 }}>
        Statistics by gender
      </Typography>
      {people && <Pie data={data} />}
      {!people && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Skeleton variant="rectangular" width={320} height={330} />
        </Box>
      )}
    </CustomPaper>
  );
}
